export const PATH = {
    HOME: '/home',
    LOGIN: '/login',
    LOGOUT: '/logout',
    WIDGET: '/widget',
    LOGIN_WITH_EMAIL: '/login/email',
    SIGNUP_CUSTOMER: '/signup',
    SIGNUP_CUSTOMER_WITH_EMAIL: '/signup/email',
    SIGNUP_ANONYMOUS_CUSTOMER: '/signup/anonymous',
    ADDITIONAL_SIGNUP_DETAILS: '/user-info',
    SIGNUP_STYLIST: '/become-a-stylist',
    NOTIFICATIONS: '/notifications',
    HOME_WAITING: '/wait-for-approval',
    INTRO: '/desktop',
    SERVER_ERROR: '/server-error',
    PATH_NOT_FOUND: '/404',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD_SUCCESS: '/reset-password-success',
    CREATE_NEW_PASSWORD: '/create-new-password',
    MY_STYLE_REQUESTS: '/my-style-requests',
    STYLE_REQUEST: '/style-request',
    // Customer
    FEED: '/recommendations',
    SEARCH_STYLES: '/style-search',
    LIST_STYLES: '/style-list',
    FATEN_UNLISTED_REVIEWED: '/unlisted-reviewed',
    HIGHLIGHT: '/highlight',
    CART: '/bag',
    PROFILE: '/profile',
    MY_STYLE_PREFERENCES: '/my-style-preferences',
    PROFILE_INFO: '/my-profile/personal',
    ODER_LIST: '/my-orders',
    CONSUMER_WARDROBE: '/wardrobe',
    WARDROBE: '/my-wardrobe',
    ODER_DETAIL: '/order',
    STYLE_DETAIL: '/style',
    ITEM_DETAIL: '/item',
    BODY_SHAPE_QUIZ: '/quiz/body-shape',
    BODY_TYPE_QUIZ: '/quiz/body-type',
    MY_BIRTHDAY_QUIZ: '/quiz/my-birthday',
    SKIN_TONE: '/quiz/skin-tone',
    PATTERN_QUIZ: '/quiz/pattern',
    MEASUREMENTS_QUIZ: '/quiz/measurements',
    BUDGET_QUIZ: '/quiz/budget',
    SKIN_UNDERTONE: '/quiz/skin-undertone',
    HAIR_COLOR: '/quiz/hair-color',
    SIZES_QUIZ: '/quiz/sizes',
    STYLE_ASSISTANT: '/amira',
    EYE_COLOR: '/quiz/eye-color',
    SOCIAL_MEDIAS: '/social-medias',
    STYLE_QUIZ: '/quiz/style',
    COLOR_QUIZ: '/quiz/colors',
    QUIZ_MANAGER: '/quiz-manager',
    QUIZ_PERSONAS: '/quiz/personas',
    CHECKOUT: '/checkout',
    RESULT: '/checkout-result',
    USER_LIKES: '/likes',
    FASHION_RESTRICTION: '/quiz/fashion-restrictions',
    HIJAB_QUIZ: '/quiz/hijab',
    STYLE_GUIDE: '/my-style-guide',
    STYLIST_PROFILE: '/stylist',
    STYLISTS: '/stylists',
    PERSONALIZED_STYLES: '/personalized',
    RELATED_STYLES: '/related-styles',
    MY_PHOTOS: '/my-photos',
    //PROFILE_CUSTOMER: '/profile_customer',
    USER_DISLIKES: '/dislikes',
    SHOW_OFF: '/quiz/show-off',
    COVER: '/quiz/cover',
    DISCOVER_YOUR_STYLE: '/discover-your-style',
    STYLE_REQUEST_QUIZ: '/order-style-request',

    // Stylist
    STYLIST_DASHBOARD: '/dashboard',
    STYLIST_TUTORIAL: '/stylist-manual',
    CREATE_STYLE: '/create-style',
    CREATE_STYLE_CANVAS: '/create-style',
    EDIT_STYLE_CANVAS: '/edit-style',
    CREATE_STYLE_PUBLISH: '/create-style-publish',
    STYLE_INFO: '/style-information',
    MY_STYLES: '/my-styles',
    MY_ITEMS: '/my-items',
    STYLE_SUGGESTIONS: '/style-suggestions',
    CONNECTED_ACCOUNTS: '/my-connected-accounts',
    VERIFY_CALENDLY: '/calendly',
    CALENDLY_MEETINGS: '/calendly-meetings',
    CONSUMER_ORDERS: '/orders',
    CONSUMER_PHOTOS: '/photos',
    CONSUMER_PROFILE_INFO: '/profile/personal',
    CONSUMER_STYLE_GUIDE: '/style-guide',
    CONSUMER_ITEMS_TO_SHOP: '/items-to-shop',
    SESSION_STYLIST_NOTES: '/session-stylist-notes',
    STYLE_REVIEW: '/style-review',

    // Gift card onboarding
    FLOWARD: '/floward',
    SESSION_INTRO: '/session-intro',
    SESSION_PURPOSE: '/style-request-purpose',
    SELECT_STYLIST: '/style-request-stylist',
    SESSION_STYLIST_DETAIL: '/session-stylist-detail',
    SELECT_SCHEDULE_TIME: '/style-session-time',
    SESSION_SCHEDULED: '/style-session-scheduled',
    REQUEST_SUCCESS: '/style-request-success',
    REVIEW_REQUEST: '/style-request-review',
    CREATE_ITEM: '/add-item',
    EDIT_ITEM: '/edit-item',

    // OLD URLS
    OLD_SESSION_PURPOSE: '/session-purpose',
    OLD_SELECT_STYLIST: '/select-stylist',
    OLD_REVIEW_REQUEST: '/review-request',
    OLD_REQUEST_SUCCESS: '/request-success',
    OLD_SELECT_SCHEDULE_TIME: '/select-schedule-time',
    OLD_SESSION_SCHEDULED: '/session-scheduled',

    OLD_ORDER_LIST: '/orders',
    OLD_STYLE_GUIDE: '/style-guide',
    OLD_PROFILE_INFO: '/profile/personal',
    OLD_SESSION_DETAIL: '/session-detail',
    OLD_CONNECTED_ACCOUNTS: '/connected-accounts',
    OLD_SESSION_DETAIL2: '/session',
    STYLE_IT_RIGHT: '/style-it-right',

    PDP_WIDGET: '/product-detail-page',
    SHARE: '/share',
};
